"use client";

import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

const AboutPageSection: React.FC = () => {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    async function getData() {
      try {
        const res = await fetch("https://portal.renvixx.com/api/content/home", {
          headers: { accept: "application/json" },
        });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Received non-JSON response from server");
        }
        const json = await res.json();
        setData(json.data.content);
      } catch (error) {
        console.error(error);
      }
    }

    getData();
  }, []);

  // Render nothing until data is available
  if (!data) return null;

  return (
    <section className="font-outfit w-full py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col-reverse lg:flex-row-reverse items-center gap-12">
        {/* ===== Left Image Section ===== */}
        <div className="relative w-full lg:w-1/2 flex justify-center">
          <div className="relative w-[89%] lg:w-full max-w-md rounded-lg overflow-visible shadow-lg border-2 border-[#2a6380]">
            <Image
              src={data.about_image || "/team/team.jpg"}
              alt={data.about_title || "Renvixx"}
              width={500}
              height={500}
              className="object-cover w-full h-full rounded-[6px]"
              priority
            />
            {/* Yellow Experience Badge */}
            <div className="absolute bottom-[20px] left-[-40px] bg-[#33c1c7] text-[#ffffff] rounded-full w-28 h-28 flex flex-col items-center justify-center shadow-lg">
              <span className="text-2xl font-bold">
                {data.about_experience_years || "10+"}
              </span>
              <span className="text-[10px] text-center leading-tight font-medium">
                Years of <br /> Experience
              </span>
            </div>
          </div>
        </div>

        {/* ===== Right Content Section ===== */}
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          {/* Subtitle */}
          <p className="text-sm text-[#000000] mb-2">
            {data.about_subtitle || "About Us"}
          </p>

          {/* Title */}
          <h2 className="text-3xl sm:text-4xl font-bold text-[#000000] mb-4">
            {data.about_title || "Who We Are"}
          </h2>

          {/* Description */}
          <div
            className="text-[#000000] leading-relaxed text-justify mb-4"
            dangerouslySetInnerHTML={{
              __html:
                data.about_description ||
                "<p>No description available at the moment.</p>",
            }}
          />

          {/* Link Button */}
          <Link
            href="/team"
            className="relative overflow-hidden inline-block border-2 border-[#2a6380] bg-[#2a6380] text-white font-semibold px-6 py-3 rounded transition-all duration-500 ease-in-out group"
          >
            <span className="relative z-10 transition-colors duration-500 group-hover:text-[#2a6380]">
              Meet Our Team
            </span>
            <span className="absolute inset-0 bg-white scale-[-1] -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutPageSection;
